// import React from "react";
// import HeaderDisplay from "./HeaderDisplay";
// import {
//   RSSComponent,
//   Shabbat,
//   CampaignCarousel,
//   NeonGrid,
//   DidYouKnowSlider,
//   MessageSlider,
//   BirthdayBanner,
// } from "../../components";

// import {
//   GridContainer,
//   TopRow,
//   TopRowLeft,
//   TopRowRight,
//   MiddleLeftColumn,
//   MiddleCenterColumn,
//   MiddleRightColumn,
//   BottomRow,
// } from "../../assets/wrappers/PublicStyle";

// const LandscapeScreen = ({
//   theme,
//   gridRows,
//   currentTime,
//   dayOfWeek,
//   weather,
//   address,
//   smallCampaign,
//   building,
//   campaign,
//   messages,
//   birthdays,
//   didYouKnowItems,
//   news,
//   getResponsiveMargin,
//   video,
//   scheduleViewsMap,
// }) => {
//   const isWeekend = ['יום שישי', 'יום שבת', 'יום שני'].includes(dayOfWeek);
//   const hasBirthdays = birthdays?.length > 0;

//   return (
//     <GridContainer
//       style={{
//         backgroundImage:
//           theme.image !== "" ? `url(${theme.image})` : theme.background,
//         color: theme.textColor,
//         display: "grid",
//         gridTemplateRows: gridRows,
//       }}
//     >
//       <TopRow style={{ background: theme.topRowBackground }}>
//         <HeaderDisplay
//           currentTime={currentTime}
//           dayOfWeek={dayOfWeek}
//           weather={weather}
//           address={address}
//           theme={theme}
//           video={video}
//         />
//       </TopRow>

//       {!isWeekend  ? (
//         <TopRowLeft>
//           <div>
//             {/* <NeonGrid firstColor="#C1CFA1" secondColor="#B1F0F7">
//             </NeonGrid> */}
//               <CampaignCarousel
//                 campaigns={smallCampaign}
//                 padding="0px"
//                 margin="0px"
//                 scheduleViewsMap={scheduleViewsMap}
//               />
//           </div>
//         </TopRowLeft>
//       ) : (
//         <div
//           style={{
//             marginTop: "40px",
//             marginRight: "10px",
//             marginLeft: "-10px",
//             height: "100%",
//           }}
//         >
//           <Shabbat
//             hebrewCityName={building.city}
//             image={theme.shabbat.image}
//             borderColor={theme.shabbat.borderColor}
//             textColor={theme.shabbat.textColor}
//             titleColor={theme.shabbat.titleColor}
//             parashaColor={theme.shabbat.parashaColor}
//             fontFamily={theme.shabbat.fontFamily}
//             blurEffect={false}
//           />
//         </div>
//       )}
//       <TopRowRight />

//       <MiddleLeftColumn>
//         {isWeekend ? (
//           <div
//             style={{
//               width: "100%",
//               height: "100%",
//               margin: "50px",
//               overflow: "auto",
//             }}
//           >
//             <DidYouKnowSlider
//               items={didYouKnowItems}
//               interval={10000}
//               orientation="landscape"
//             />
//           </div>
//         ) : hasBirthdays ? (
//           <div
//             style={{
//               width: "100%",
//               height: "100%",
//               margin: "50px 50px 0px 50px",
//               overflow: "auto",
//             }}
//           >
//             <BirthdayBanner
//               birthdayMessages={birthdays}
//               neonColor1={theme.message.birthdayColor1}
//               neonColor2={theme.message.birthdayColor2}
//               neonText={theme.message.neonText}
//               background={theme.message.neonBackground}
//               backgroundImage={theme.message.backgroundImage}
//               fontFamily={theme.message.fontFamily}
//             />
//           </div>
//         ) : building.DidYouKnow !== "ללא" && didYouKnowItems?.length > 0 ? (
//           <div
//             style={{
//               width: "100%",
//               height: "100%",
//               overflow: "auto",
//               margin: "50px 20px 20px 20px",
//             }}
//           >
//             <DidYouKnowSlider
//               items={didYouKnowItems}
//               interval={10000}
//               orientation="landscape"
//             />
//           </div>
//         ) : null}

//         <div
//           style={{
//             width: "100%",
//             height: "100%",
//             overflow: "auto",
//             gridRow: building.DidYouKnow !== "לאחר" ? "1 / span 2" : undefined,
//           }}
//         >
//           {messages?.length > 0 && (
//             <MessageSlider
//               key={messages.length}
//               initialMessages={messages}
//               titleBackground={theme.message.titleBackground}
//               textColor={theme.message.textColor}
//               background={theme.message.messageBackground}
//               neonBackground={theme.message.neonBackground}
//               neonText={theme.message.neonText}
//               neonColor1={theme.message.neonColor1}
//               neonColor2={theme.message.neonColor2}
//               birthdayColor1={theme.message.birthdayColor1}
//               birthdayColor2={theme.message.birthdayColor2}
//             />
//           )}
//         </div>
//       </MiddleLeftColumn>
//       <MiddleCenterColumn>
//         <CampaignCarousel
//           campaigns={campaign}
//           margin={getResponsiveMargin()}
//           scheduleViewsMap={scheduleViewsMap}
//         />
//       </MiddleCenterColumn>

//       <MiddleRightColumn />
//       <BottomRow>
//         {news && news.news && news.news.length > 0 ? (
//           <RSSComponent
//             data={news}
//             textColor={theme.rss.textColor}
//             background={theme.rss.background}
//             fontFamily={theme.rss.fontFamily}
//             logoBackground={"#e30613"}
//             logoTextColor={"white"}
//             {...(news.name === "מבזקים" && {
//               logoImage:
//                 "https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/ec/c5/ca/ecc5cadf-e344-f9d5-cceb-33391e8dbefe/AppIcon-0-0-1x_U007epad-0-1-85-220.png/230x0w.webp",
//             })}
//           />
//         ) : (
//           <div
//             style={{
//               width: "100%",
//               textAlign: "center",
//               color: theme.rss.textColor,
//               background: theme.rss.background,
//               padding: "20px",
//               fontFamily: theme.rss.fontFamily,
//             }}
//           >
//             רוצים לפרסם אצלנו ? חייגו 054-5316460
//           </div>
//         )}
//       </BottomRow>
//     </GridContainer>
//   );
// };

// export default LandscapeScreen;



import PropTypes from 'prop-types';
import HeaderDisplay from './HeaderDisplay';
import {
  RSSComponent,
  Shabbat,
  CampaignCarousel,
  DidYouKnowSlider,
  MessageSlider,
  BirthdayBanner,
} from '../../components';

import {
  GridContainer,
  TopRow,
  TopRowLeft,
  TopRowRight,
  MiddleLeftColumn,
  MiddleCenterColumn,
  MiddleRightColumn,
  BottomRow,
} from '../../assets/wrappers/PublicStyle';

const LandscapeScreen = ({
  theme,
  gridRows,
  currentTime,
  dayOfWeek,
  weather,
  address,
  smallCampaign,
  building,
  campaign,
  messages,
  birthdays,
  didYouKnowItems,
  news,
  getResponsiveMargin,
  video,
  scheduleViewsMap,
}) => {
  const isWeekend = ['יום שישי', 'יום שבת'].includes(dayOfWeek);
  const hasBirthdays = birthdays?.length > 0;
  const hasMessages = messages?.length > 0;
  const hasSmallCampaign = smallCampaign?.length > 0;

  // Three mutually exclusive Shabbat placements — never shown twice:
  // 1. showShabbatTop: weekend + campaign + messages → Shabbat replaces campaign slot (small)
  // 2. showShabbatColumn: no campaign → Shabbat fills entire MiddleLeftColumn (big), DidYouKnow hidden
  // 3. showShabbatMessages: campaign + no messages → Shabbat replaces messages slot (small)
  const showShabbatTop = isWeekend && hasSmallCampaign && hasMessages;
  const showShabbatColumn = !hasSmallCampaign;
  const showShabbatMessages = hasSmallCampaign && !hasMessages;

  return (
    <GridContainer
      style={{
        backgroundImage:
          theme.image !== '' ? `url(${theme.image})` : theme.background,
        color: theme.textColor,
        display: 'grid',
        gridTemplateRows: gridRows,
      }}
    >
      <TopRow style={{ background: theme.topRowBackground }}>
        <HeaderDisplay
          currentTime={currentTime}
          dayOfWeek={dayOfWeek}
          weather={weather}
          address={address}
          theme={theme}
          video={video}
        />
      </TopRow>

      {showShabbatTop ? (
        <div style={{ marginTop: '40px', marginRight: '10px', marginLeft: '-10px', height: '100%' }}>
          <Shabbat
            hebrewCityName={building.city}
            image={theme.shabbat.image}
            borderColor={theme.shabbat.borderColor}
            textColor={theme.shabbat.textColor}
            titleColor={theme.shabbat.titleColor}
            parashaColor={theme.shabbat.parashaColor}
            fontFamily={theme.shabbat.fontFamily}
            blurEffect={false}
          />
        </div>
      ) : hasSmallCampaign ? (
        <TopRowLeft>
          <div>
            <CampaignCarousel
              campaigns={smallCampaign}
              padding='0px'
              margin='0px'
              scheduleViewsMap={scheduleViewsMap}
            />
          </div>
        </TopRowLeft>
      ) : null}
      <TopRowRight />

      <MiddleLeftColumn>
        {/* DidYouKnow / Birthday — always shown regardless of Shabbat placement */}
        {isWeekend ? (
          <div style={{ width: '100%', height: '100%', margin: '50px', overflow: 'auto' }}>
            <DidYouKnowSlider items={didYouKnowItems} interval={10000} orientation='landscape' />
          </div>
        ) : hasBirthdays ? (
          <div style={{ width: '100%', height: '100%', margin: '50px 50px 0px 50px', overflow: 'auto' }}>
            <BirthdayBanner
              birthdayMessages={birthdays}
              neonColor1={theme.message.birthdayColor1}
              neonColor2={theme.message.birthdayColor2}
              neonText={theme.message.neonText}
              background={theme.message.neonBackground}
              backgroundImage={theme.message.backgroundImage}
              fontFamily={theme.message.fontFamily}
            />
          </div>
        ) : building.DidYouKnow !== 'ללא' && didYouKnowItems?.length > 0 ? (
          <div style={{ width: '100%', overflow: 'auto', margin: '15px 20px 0px 20px' }}>
            <DidYouKnowSlider items={didYouKnowItems} interval={10000} orientation='landscape' />
          </div>
        ) : null}

        {/* Bottom slot: Shabbat (when no campaign OR campaign+no messages) or messages */}
        <div style={{ width: '100%', height: '100%', overflow: 'auto' }}>
          {showShabbatColumn || showShabbatMessages ? (
            <Shabbat
              hebrewCityName={building.city}
              image={theme.shabbat.image}
              borderColor={theme.shabbat.borderColor}
              textColor={theme.shabbat.textColor}
              titleColor={theme.shabbat.titleColor}
              parashaColor={theme.shabbat.parashaColor}
              fontFamily={theme.shabbat.fontFamily}
              blurEffect={false}
            />
          ) : hasMessages ? (
            <MessageSlider
              key={messages.length}
              initialMessages={messages}
              titleBackground={theme.message.titleBackground}
              textColor={theme.message.textColor}
              background={theme.message.messageBackground}
              neonBackground={theme.message.neonBackground}
              neonText={theme.message.neonText}
              neonColor1={theme.message.neonColor1}
              neonColor2={theme.message.neonColor2}
              birthdayColor1={theme.message.birthdayColor1}
              birthdayColor2={theme.message.birthdayColor2}
            />
          ) : null}
        </div>
      </MiddleLeftColumn>
      <MiddleCenterColumn>
        <CampaignCarousel
          campaigns={campaign}
          margin={getResponsiveMargin()}
          scheduleViewsMap={scheduleViewsMap}
        />
      </MiddleCenterColumn>

      <MiddleRightColumn />
      <BottomRow>
        {news && news.news && news.news.length > 0 ? (
          <RSSComponent
            data={news}
            textColor={theme.rss.textColor}
            background={theme.rss.background}
            fontFamily={theme.rss.fontFamily}
            logoBackground={'#e30613'}
            logoTextColor={'white'}
            {...(news.name === 'מבזקים' && {
              logoImage:
                'https://is1-ssl.mzstatic.com/image/thumb/Purple211/v4/ec/c5/ca/ecc5cadf-e344-f9d5-cceb-33391e8dbefe/AppIcon-0-0-1x_U007epad-0-1-85-220.png/230x0w.webp',
            })}
          />
        ) : (
          <div
            style={{
              width: '100%',
              textAlign: 'center',
              color: theme.rss.textColor,
              background: theme.rss.background,
              padding: '20px',
              fontFamily: theme.rss.fontFamily,
            }}
          >
            רוצים לפרסם אצלנו ? חייגו 054-5316460
          </div>
        )}
      </BottomRow>
    </GridContainer>
  );
};

export default LandscapeScreen;

LandscapeScreen.propTypes = {
  theme: PropTypes.object.isRequired,
  gridRows: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  currentTime: PropTypes.string,
  dayOfWeek: PropTypes.string,
  weather: PropTypes.object,
  address: PropTypes.string,
  smallCampaign: PropTypes.array,
  building: PropTypes.object,
  campaign: PropTypes.array,
  messages: PropTypes.array,
  birthdays: PropTypes.array,
  didYouKnowItems: PropTypes.array,
  news: PropTypes.object,
  getResponsiveMargin: PropTypes.func,
  video: PropTypes.object,
  scheduleViewsMap: PropTypes.object,
};
